import React, {Component} from 'react';
import Aux from '../Hoc/Aux.js';
import Connect from '../../components/Forms/Connect';
import { Link } from 'react-router-dom';

import { updateStepIfDifferent } from '../../helpers/routes';
import * as QuizHelpers from '../../helpers/quiz';

import _ from 'lodash';

class Employees extends Component {
  state = {
    animate: ''
  }

  componentDidMount () {
    const p = _.clone(this.props);
    p.toggleInQuiz(true);
    p.setFieldValue('QuizRoute', `${this.props.route}`);
    QuizHelpers.sendAnalyticsOnQuestion(`${p.route}`, '# Employees');
    setTimeout(() => {
      this.setState({
        animate: 'fadeIn'
      });
    }, 600);
  }

  _handleEmployeeChange (e) {
    const employeeCount = e.target.value;

    if (employeeCount.length <= 3) {
      this.props.reducer(employeeCount);

      if (employeeCount.length >= 1) {
        var that = this;
        setTimeout(function () {
          that.setState({message: true});
        }, 100);

        if (employeeCount > 100) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'GAEvent',
            'eventCategory': 'Error',
            'eventAction': 'Inline',
            'eventLabel': 'Email for Large Group', // when >100 employeees
            'eventValue': undefined
          });
        }

        if (employeeCount < 2) {
          setTimeout(function () {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'GAEvent',
              'eventCategory': 'Error',
              'eventAction': 'Inline',
              'eventLabel': 'Sole Prop', // when <2 employees
              'eventValue': undefined
            });
          }, 500);
        }
      }
    }
  }

  _validate (val = this.props.quiz.fieldValues.FullTimeEmployees) {
    const isValid = (val > 1 && val <= 100);
    if (!isValid) updateStepIfDifferent(this.props.quiz.step);
    return isValid;
  }

  triggerGAEvent () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'GAEvent',
      'eventCategory': 'Click',
      'eventAction': 'Launch Email',
      'eventLabel': 'Email re: Large Group',
      'eventValue': undefined
    });
  }

  render () {
    const p = _.clone(this.props);
    const employees = p.quiz.fieldValues.FullTimeEmployees;

    const isEnabled = this._validate(employees);

    let notice;
    let showForm = false;
    if (employees > 0) {
      if (employees < 2) {
        notice = <p className='info'>Sounds like you’re a sole proprietor and qualify for an <Link to='/individuals/find-a-plan/start'>individual plan</Link>.</p>;
        showForm = false;
      } else if (employees > 100) {
        notice =
          <p className='info'>
            You&rsquo;re going to require large group insurance.
          </p>;
        showForm = <div className='large-group-form'>
          <h5>Please complete the form below and a member of our team will be in touch to discuss your needs.</h5>
          <Connect
            area='LargeGroupLead'
            gaEventLabel='Plans - Large Group Lead'
            displayInline />
        </div>;
      }
    }

    return (
      <Aux>
        <section className={'p30 text-center animate ' + this.state.animate}>
          <div className='wrap'>
            <h3>How many full-time employees do you have?</h3>
            <p>If you’re not insuring employees, find a plan for <Link to='/individuals/find-a-plan/start'>yourself</Link> or your <Link to='/families/find-a-plan/'>spouse and family</Link>.</p>
            <p className='form'>
              <input
                id='employees'
                type='number'
                autoFocus
                name='FullTimeEmployees'
                maxLength='3'
                value={employees}
                onChange={(e) => this._handleEmployeeChange(e)}
                onKeyUp={(e) =>
                  (e.which === 13 &&
                    isEnabled &&
                    this.props.stepMethods.isNextStep() &&
                    this.props.stepMethods.nextStep()
                  )
                }
              />
              {this.props.stepMethods.isNextStep() &&
              <button
                className={'btn next ' + isEnabled}
                disabled={!isEnabled}
                onClick={this.props.stepMethods.nextStep}
              >Next</button>}
            </p>

            <div className={'message' + (notice ? ' show' : '')}>
              {notice}
            </div>
          </div>
        </section>
        {showForm}
      </Aux>
    );
  }
}

Employees.propTypes = { // validate props expected
};

export default Employees;